
import React, { useState } from 'react';
import { Users, User, ArrowRight, ChevronLeft, CheckCircle2 } from 'lucide-react';

interface OnboardingStep3Props {
  onNext: (isShared: boolean) => void;
  onBack: () => void;
}

export const OnboardingStep3: React.FC<OnboardingStep3Props> = ({ onNext, onBack }) => {
  const [isShared, setIsShared] = useState<boolean>(true);

  const handleSubmit = () => {
    onNext(isShared);
  };

  return (
    <div className="min-h-screen mesh-gradient flex flex-col px-8 pt-12 pb-10 animate-fadeIn">
      <div className="mb-12 flex items-center gap-4">
        <button onClick={onBack} className="p-2 bg-white dark:bg-slate-900 rounded-full shadow-sm">
          <ChevronLeft size={20} className="text-slate-500" />
        </button>
        <div className="flex-1 h-2 bg-slate-200 dark:bg-slate-800 rounded-full overflow-hidden">
          <div className="h-full bg-emerald-500 w-3/4 rounded-full transition-all duration-700 ease-out shadow-[0_0_10px_rgba(16,185,129,0.3)]"></div>
        </div>
        <span className="text-[10px] font-black text-emerald-600 uppercase tracking-widest">3 / 4</span>
      </div>

      <div className="mb-10 text-center">
        <h2 className="text-3xl font-black text-emerald-900 dark:text-white tracking-tighter leading-tight mb-4">
          Como pretende <br/><span className="text-emerald-600">gerenciar?</span>
        </h2>
        <p className="text-slate-600 dark:text-slate-400 text-sm font-medium leading-relaxed max-w-[280px] mx-auto">
          A obra flui melhor com colaboração. Escolha como quer acompanhar os dados.
        </p>
      </div>

      <div className="space-y-4 flex-1">
        <button
          onClick={() => setIsShared(true)}
          className={`w-full p-6 rounded-[2.5rem] border-2 transition-all flex items-center gap-6 text-left relative overflow-hidden group ${isShared ? 'bg-emerald-50 border-emerald-500 dark:bg-emerald-800/20 shadow-xl' : 'bg-white border-slate-100 dark:bg-slate-800 dark:border-slate-700'}`}
        >
          <div className={`p-4 rounded-3xl transition-all ${isShared ? 'bg-emerald-500 text-white shadow-lg' : 'bg-slate-100 text-slate-400 dark:bg-slate-700'}`}>
            <Users size={28} />
          </div>
          <div>
            <h4 className={`font-black uppercase text-[10px] tracking-widest mb-1 ${isShared ? 'text-emerald-700 dark:text-emerald-400' : 'text-slate-400'}`}>Acesso Compartilhado</h4>
            <p className={`font-bold text-sm ${isShared ? 'text-emerald-900 dark:text-white' : 'text-slate-500'}`}>Sincronização em tempo real com parceiros, engenheiros ou família.</p>
          </div>
          {isShared && <CheckCircle2 size={24} className="absolute top-4 right-4 text-emerald-500" />}
        </button>

        <button
          onClick={() => setIsShared(false)}
          className={`w-full p-6 rounded-[2.5rem] border-2 transition-all flex items-center gap-6 text-left relative overflow-hidden group ${!isShared ? 'bg-emerald-50 border-emerald-500 dark:bg-emerald-800/20 shadow-xl' : 'bg-white border-slate-100 dark:bg-slate-800 dark:border-slate-700'}`}
        >
          <div className={`p-4 rounded-3xl transition-all ${!isShared ? 'bg-emerald-500 text-white shadow-lg' : 'bg-slate-100 text-slate-400 dark:bg-slate-700'}`}>
            <User size={28} />
          </div>
          <div>
            <h4 className={`font-black uppercase text-[10px] tracking-widest mb-1 ${!isShared ? 'text-emerald-700 dark:text-emerald-400' : 'text-slate-400'}`}>Acompanhar Individualmente</h4>
            <p className={`font-bold text-sm ${!isShared ? 'text-emerald-900 dark:text-white' : 'text-slate-500'}`}>Apenas você terá acesso ao controle e lançamentos.</p>
          </div>
          {!isShared && <CheckCircle2 size={24} className="absolute top-4 right-4 text-emerald-500" />}
        </button>
      </div>

      <div className="pt-8">
        <button 
          onClick={handleSubmit}
          className="w-full bg-emerald-800 dark:bg-emerald-600 text-white py-5 rounded-[2rem] font-black text-xs uppercase tracking-widest shadow-2xl flex items-center justify-center gap-3 active:scale-95 transition-all animate-pulsar-premium"
        >
          Configurar Metas
          <ArrowRight size={18} />
        </button>
      </div>
    </div>
  );
};